<template>
  <div class="settings-view">
    <section class="panel-header-section">
      <h2 class="section-title">System Settings</h2>
      <p class="section-subtitle">Configure device behavior and control parameters.</p>
    </section>

    <section class="settings-grid">
      <div class="setting-card">
        <div class="setting-info">
          <h3>Door Sensor Notifications</h3>
          <p>Push alerts when the door sensor changes state.</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" v-model="notifState" @change="switchNotifState">
          <span class="toggle-track">
            <span class="toggle-thumb"></span>
          </span>
        </label>
      </div>
    </section>

    <section class="toast-panel" v-if="error || success">
      <div class="toast" :class="{ error: error, success: success }">
        <span>{{ error || success }}</span>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SettingsView',
  props: {
    msg: String
  },
  data() {
    return {
      error: '',
      success: '',
      notifState: false
    }
  },
  methods: {
    showToast(message, isError = false) {
      if (isError) {
        this.error = message
      } else {
        this.success = message
      }
      setTimeout(() => {
        this.error = ''
        this.success = ''
      }, 3000)
    },
    switchNotifState() {
      const message = this.notifState ? 'notification_on' : 'notification_off'

      this.axios.get(process.env.VUE_APP_BACK_URL + '/mqtt/send?topic=sensor/door&message=' + message)
          .then(res => {
            if (res.data.success) {
              this.getNotifState()
              this.showToast(this.notifState ? 'Notifications enabled' : 'Notifications disabled')
            } else {
              this.showToast('Command failed', true)
            }
          })
          .catch(err => {
            let message = 'Request failed'
            if (err.response && err.response.status >= 500) {
              message = 'Server error'
            } else if (err.response) {
              message = err.response.data.message || 'Request failed'
            }
            this.showToast(message, true)
          })
    },
    getNotifState() {
      this.axios.get(process.env.VUE_APP_BACK_URL + '/settings?name=notification')
          .then(res => {
            const setting = Array.isArray(res.data) ? res.data[0] : null
            this.notifState = Boolean(Number(setting?.status))
          })
          .catch(err => {
            let message = 'Request failed'
            if (err.response && err.response.status >= 500) {
              message = 'Server error'
            } else if (err.response) {
              message = err.response.data.message || 'Request failed'
            }
            this.showToast(message, true)
          })
    }
  },
  mounted() {
    this.getNotifState()
  }
}
</script>

<style scoped>
.settings-view {
  max-width: 1200px;
}

.panel-header-section {
  margin-bottom: 28px;
}

.section-title {
  font-family: var(--font-display);
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 8px;
}

.section-subtitle {
  color: var(--text-secondary);
  margin: 0;
}

.settings-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.setting-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;
  border-radius: var(--radius);
  background: var(--surface);
  border: 1px solid var(--border);
  transition: border-color 0.2s ease;
}

.setting-card:hover {
  border-color: var(--border-strong);
}

.setting-info h3 {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0 0 6px;
}

.setting-info p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 30px;
  cursor: pointer;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-track {
  position: absolute;
  inset: 0;
  border-radius: 30px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  transition: all 0.25s ease;
}

.toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--text-secondary);
  transition: all 0.25s ease;
}

.toggle-switch input:checked + .toggle-track {
  background: var(--accent-dim);
  border-color: rgba(0, 212, 255, 0.35);
}

.toggle-switch input:checked + .toggle-track .toggle-thumb {
  transform: translateX(26px);
  background: var(--accent);
  box-shadow: 0 0 12px var(--accent);
}

.toast-panel {
  margin-top: 24px;
}

.toast {
  padding: 14px 18px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
}

.toast.success {
  background: rgba(0, 230, 118, 0.1);
  color: var(--success);
  border: 1px solid rgba(0, 230, 118, 0.2);
}

.toast.error {
  background: var(--danger-bg);
  color: var(--danger);
  border: 1px solid rgba(255, 82, 82, 0.2);
}

@media (max-width: 560px) {
  .setting-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
</style>
